import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement("circle", { cx: 12, cy: 12, r: 12, fill: "currentColor", opacity: 0.2 }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M16.125 7.042c.46 0 .833.373.833.833v8.25a.833.833 0 0 1-1.666 0V9.887l-6.827 6.827a.833.833 0 0 1-1.179-1.178l6.827-6.827H7.875a.833.833 0 1 1 0-1.667z",
      clipRule: "evenodd"
    }
  )
);
var SvgCircledDiagonalUpOutlinedFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledDiagonalUpOutlinedFilled_default = SvgCircledDiagonalUpOutlinedFilled;

export { CircledDiagonalUpOutlinedFilled_default as default };
